import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'
import moment from 'moment';

import { SingleRedio, SingleText, SingleInput } from '../../../Res/BaseInput';
import { CancelSubmitButton, Space, EditButton } from '../../../Res/BaseButton';
import { ContentBox } from '../../../Content/ContentBox';
import { SystemPromptInput } from '../../../Res/SystemPrompt';
import { getval2Token } from '../../../../Login/Auth';
import { api_addPark, api_getParkDetail, api_checkParkName } from '../../../../../api/MyStat/apiPark';
import { ReqParkDetail, RespPark } from '../../../../../item/MyStat/ItemPark';
import { UploadPhoto } from '../UploadPhoto';
import { get_activation_string, activation_Items } from '../../../../../item/MyStat/ItemMyStatBase';
import { DatePickerInput } from 'rc-datepicker';
import 'rc-datepicker/lib/style.css';


export function ParkEdit({ id, setIsLoading, isEdit, isAdd = false }) {
  const [tokenId, setTokenId] = useState("")

  const [_id, set_id] = useState("")
  const [park_id, set_park_id] = useState("")
  const [park_name, set_park_name] = useState("")
  const [park_name_eng, set_park_name_eng] = useState("")
  const [park_activation, set_park_activation] = useState(1)
  const [park_last_change, set_park_last_change] = useState("")
  const [park_note, set_park_note] = useState("")

  const [park_pic_profile, set_park_pic_profile] = useState("")
  const [park_pic_profile_auth, set_park_pic_profile_auth] = useState(0)
  const [park_pic_profile_date, set_park_pic_profile_date] = useState("")

  const [park_plan, set_park_plan] = useState("")
  const [park_plan_auth, set_park_plan_auth] = useState(0)
  const [park_plan_date, set_park_plan_date] = useState("")

  const [isCheckRepeat, setCheckRepeat] = useState(false)
  const [isRepeat, setRepeat] = useState(false)
  const [repeatMessage, setRepeatMessage] = useState("")

  const [birthError, setBirthError] = useState(false)

  useEffect(() => {
    if (id !== undefined && id !== tokenId) {
      var obj = getval2Token("ParkEdit", id)
      console.log(obj)
      set_park_id(obj.park_id)
      setTokenId(id)
    }
  }, [id])

  useEffect(() => {
    if (park_id !== undefined && park_id !== "") {
      // setIsLoading(true)
      var mReqParkDetail = new ReqParkDetail({
        park_id
      })
      getDetail(mReqParkDetail)
    }
  }, [park_id])

  function getDetail(mReqParkDetail) {
    console.log(mReqParkDetail)
    setIsLoading(true)
    api_getParkDetail({
      mReqParkDetail,
      success: (jsonData) => {
        console.log(jsonData)
        var mRespPark = new RespPark({})
        mRespPark.fromJson(jsonData.detail)

        set_id(mRespPark._id)
        set_park_name(mRespPark.park_name)
        set_park_name_eng(mRespPark.park_name_eng)
        set_park_activation(mRespPark.park_activation)
        set_park_last_change(moment(mRespPark.park_last_change).format('YYYY-MM-DD'))
        set_park_note(mRespPark.park_note)
        set_park_pic_profile(mRespPark.park_pic_profile)
        set_park_pic_profile_auth(mRespPark.park_pic_profile_auth)
        
        var pic_profile_date = moment(mRespPark.park_pic_profile_date).format('YYYY-MM-DD HH:mm:ss')
        if (pic_profile_date === "Invalid date")
          pic_profile_date = ""
        set_park_pic_profile_date(pic_profile_date)

        set_park_plan(mRespPark.park_plan)
        set_park_plan_auth(mRespPark.park_plan_auth)

        var pic_game_date = moment(mRespPark.pic_game_date).format('YYYY-MM-DD HH:mm:ss')
        if (pic_game_date === "Invalid date")
          pic_game_date = ""
        set_park_plan_date(pic_game_date)

        setIsLoading(false)
      },
      failure: (err) => {
        console.log(err)
        setIsLoading(false)
      }
    })
  }


  function checkName(val) {
    setIsLoading(true)
    var mRespPark = new RespPark({
      park_name: val,
    })
    console.log(mRespPark)
    api_checkParkName({
      mRespPark,
      success: (jsonData) => {
        console.log(jsonData)
        setIsLoading(false)
        setCheckRepeat(true)
        if (jsonData.id === "") {
          setRepeat(false)
          setRepeatMessage("此球場名稱無重覆")
        } else {
          setRepeat(true)
          setRepeatMessage("與球場編號" + jsonData.id + "同名")
        }
      },
      failure: (err) => {
        console.log(err)
        setIsLoading(false)
        Swal.fire({
          type: 'error',
          title: '提醒',
          text: err,
        })
      }
    })
  }

  function toEdit() {
    window.location.assign("/Park_Edit/" + id);
  }

  function toCancel() {
    window.history.back();
  }

  function toAdd() {
    // console.log(park_type)
    var inputError = []
    if (park_name === "") {
      inputError.push("中文名字")
    }

    if (inputError.length > 0) {
      Swal.fire({
        type: 'error',
        title: '提醒',
        text: inputError.join(',') + ' 為必填',
      })
      return
    }

    setIsLoading(true)
    var mRespPark = new RespPark({
      park_id,
      park_name,
      park_name_eng,
      park_activation,
      park_last_change,
      park_note,
      park_pic_profile,
      park_pic_profile_auth,
      park_pic_profile_date,
      park_plan,
      park_plan_auth,
      park_plan_date
    })

    console.log(mRespPark)
    api_addPark({
      isAdd,
      mRespPark,
      success: (jsonData) => {
        setIsLoading(false)
        Swal.fire({
          type: 'success',
          title: '提醒',
          text: isAdd ? '新增成功' : '修改成功',
        }).then(function () {
          toCancel()
        })
      },
      failure: (err) => {
        setIsLoading(false)
        Swal.fire({
          type: 'error',
          title: '提醒',
          text: err,
        })
      }
    })
  }

  var title = "球場" + (isAdd ? "新增" : isEdit ? "編輯" : "檢視")
  var content =
    <>
      <div className="row">
        <div className="col-sm-12">

          <div className="col-md-6">
            <UploadPhoto
              title={"擊球落點底圖"}
              Photo={park_pic_profile}
              PhotoAuth={park_pic_profile_auth}
              PhotoDate={park_pic_profile_date}
              setIsLoading={setIsLoading}
              set_Photo={set_park_pic_profile}
              set_PhotoAuth={set_park_pic_profile_auth}
              set_PhotoDate={set_park_pic_profile_date}
              isEdit={isEdit}
            />

            <UploadPhoto
              title={"球場背景"}
              Photo={park_plan}
              PhotoAuth={park_plan_auth}
              PhotoDate={park_plan_date}
              setIsLoading={setIsLoading}
              set_Photo={set_park_plan}
              set_PhotoAuth={set_park_plan_auth}
              set_PhotoDate={set_park_plan_date}
              isEdit={isEdit}
            />
          </div>

          <div className="col-md-6">
            <div className="row">
              {isEdit ?
                <SingleInput title={"中文名稱"} val={park_name} action={set_park_name} action_blur={checkName} placeholder={""} size={8} />
                : <SingleText title={"中文名稱"} val={park_name} size={8} />
              }
            </div>
            {isCheckRepeat ?
              <div className="row">
                <div className="col-md-4">
                  <p className={isRepeat ? "text-danger" : "text-info"}>{repeatMessage}</p>
                </div>
              </div>
              : <></>}
            <Space />
            <Space />
            <Space />
            <Space />
            <div className="row">
              {isEdit ?
                <SingleInput title={"英文名稱"} val={park_name_eng} action={set_park_name_eng} placeholder={""} size={8} />
                : <SingleText title={"英文名稱"} val={park_name_eng} size={8} />
              }
              {isAdd ?
                <></>
                : <SingleText title={"編號"} val={_id} size={4} />
              }

            </div>
            <Space />
            <Space />
            <Space />
            <Space />
            <div className="row">
              {
                isEdit ?
                  <SingleRedio title={"啟停用"}
                    arr={activation_Items}
                    val={park_activation ? 1 : 0}
                    action={set_park_activation}
                    size={4}
                  />
                  :
                  <SingleText title={"啟停用"}
                    val={get_activation_string(park_activation)}
                    size={4} />
              }
              {isAdd ?
                <></>
                : <SingleText title={"異動日期"} val={park_last_change} size={4} />
              }

            </div>
            <Space />
            <Space />
            <Space />
            <Space />
            <div className="row">
              {isEdit ?
                <SingleInput title={"註記"} val={park_note} action={set_park_note} placeholder={"內部人員註記"} size={12} />
                : <SingleText title={"註記"} val={park_note} size={12} />
              }
            </div>
          </div>



        </div>
      </div>
    </>

  var footer =
    <div className="row">
      <div className="row">
        {
          isAdd || isEdit ?
            <div className="col-sm-3 col-sm-offset-9">
              <CancelSubmitButton cancelAction={toCancel} submitName={"儲存"} submitAction={toAdd} isRight={true} />
            </div>
            :
            <EditButton action={toEdit} isRight={true} />
        }
      </div>
    </div>

  return (
    <>
      <ContentBox title={title} content={content} footer={footer} hasDrawer={false} />
      <SystemPromptInput />
    </>
  )
}